// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2Nygl","author":"Table_author__19EZp","authorImage":"Table_authorImage__1uxDH","unreadRow":"Table_unreadRow__3Wgg_"};